/**
 * An export is a file download, so it is a real form post rather than an XHR:
 * the browser saves the response itself.
 *
 * @param {string} url
 * @param {Array<[string, string|number]>} fields
 */
export default function submitExport(url, fields) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.style.display = 'none';

    const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    };

    add('_token', document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '');
    fields.forEach(([name, value]) => add(name, value));

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}

/**
 * The picker's { eventId: { enabled, budget } } selection as form fields.
 *
 * @param {Object<string, {enabled: boolean, budget: number|null}>} filterData
 * @returns {Array<[string, string|number]>}
 */
export function selectionFields(filterData) {
    const fields = [];

    Object.entries(filterData).forEach(([eventId, entry]) => {
        fields.push([`filters[${eventId}][enabled]`, entry.enabled ? '1' : '0']);
        fields.push([`filters[${eventId}][budget]`, entry.budget ?? '']);
    });

    return fields;
}
